import Api from '@/api'

export default {
    namespaced: true,
    state: {
        results: null
    },
    actions: {
        async fetch ({commit}) {
            let json = await Api.GET('api/get_result')
            commit('results', json)
        }
    },
    mutations: {
        results (state, data) {
            state.results = data
        }
    }
}
